import React from 'react';
import { Card, CardContent, CardActions, Typography, Grid, Button, Box, Stack } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Logo from '../../assets/img/icon.png';

const ProductCard = ({ title, description, buttons, productUrl, url }) => {
    const isMobile = useMediaQuery('(max-width:600px)');

    const truncatedDescription = description.length > 200 ? description.substring(0, 200) + '...' : description;

    return (
        <Card
            sx={{
                margin: 2,
                borderRadius: 4,
                height: {
                    xs: 'auto',
                    sm: '300px'
                },
                display: 'flex',
                flexDirection: 'column'
            }}
            elevation={4}
        >
            <CardContent sx={{ flexGrow: 1, paddingBottom: '16px' }}>
                <Grid container direction='column' alignItems='flex-start' spacing={2}>
                    <Grid item>
                        <Box
                            component='img'
                            src={productUrl || Logo}
                            alt='Product or Logo'
                            sx={{
                                width: '60px',
                                height: {
                                    xs: 'auto',
                                    sm: '60px'
                                },
                                maxWidth: '100%',
                                borderRadius: '10px',
                                boxShadow: 3
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <Typography
                            variant='h6'
                            component='div'
                            sx={{
                                fontWeight: '600',
                                height: {
                                    xs: 'auto',
                                    sm: '45px'
                                }
                            }}
                        >
                            {title}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid item xs={12}>
                            <Typography
                                variant='body2'
                                color='text.secondary'
                                sx={{
                                    whiteSpace: 'normal',
                                    overflowWrap: 'break-word',
                                    lineHeight: '1.6',
                                    wordBreak: 'break-word',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxHeight: '6.4rem'
                                }}
                            >
                                {truncatedDescription}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>

            <CardActions
                sx={{
                    justifyContent: 'flex-start',
                    padding: 2
                }}
            >
                <Stack direction={isMobile ? 'column' : 'row'} spacing={1} alignItems='center' width='100%'>
                    {buttons.map((button, index) => (
                        <Button
                            key={index}
                            variant='outlined'
                            startIcon={button.icon}
                            onClick={button.onClick}
                            size='small'
                            fullWidth={isMobile}
                            sx={{
                                margin: isMobile ? '5px 0' : 'auto',
                                borderColor: button.color,
                                borderRadius: 5,
                                color: button.color,
                                '&:hover': {
                                    borderColor: button.color,
                                    backgroundColor: `${button.color}20`
                                }
                            }}
                        >
                            {button.title}
                        </Button>
                    ))}
                </Stack>
            </CardActions>
        </Card>
    );
};

export default ProductCard;
